// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__2G5S3","pageActive":"styles_pageActive__dzOol","page":"styles_page__3qDD7","next":"styles_next__3Jsrl","previous":"styles_previous__2dayA"};